import React from 'react';
import ReactDOM from 'react-dom/client'; // Update the import
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './utils/i18n.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);